import { Table, Tag, Tooltip } from "antd";

// 🔥 Helpers (2 decimales SIEMPRE)
const formatNumber = (value) => {
  if (value === null || value === undefined) return "0.00";
  return Number(value).toLocaleString("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "$ 0.00";
  return Number(value).toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export default function DetalleTable({ data }) {
  const columns = [
    {
      title: "#",
      width: 60,
      align: "center",
      render: (_, __, index) => index + 1
    },
    {
      title: "Producto",
      dataIndex: "nombre_producto",
      width: 300,
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 280,
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.2em"
            }}
          >
            {text}
          </div>
        </Tooltip>
      )
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad_total",
      align: "center",
      width: 120,
      render: formatNumber
    },
    {
      title: "Entregado",
      dataIndex: "cantidad_entregada",
      align: "center",
      width: 120,
      render: formatNumber
    },
    {
      title: "Pendiente",
      dataIndex: "pendiente",
      align: "center",
      width: 120,
      render: (v) => {
        const value = Number(v) || 0;
        return (
          <span style={{ color: value > 0 ? "#faad14" : "#52c41a" }}>
            {formatNumber(value)}
          </span>
        );
      }
    },
    {
      title: "Valor Unitario",
      align: "right",
      width: 150,
      render: (_, r) => formatCurrency(r.valor_unitario_COP)
    },
    {
      title: "Valor Total",
      align: "right",
      width: 150,
      render: (_, r) => (
        <Tooltip title="Valor total del producto">
          <span style={{ fontWeight: 600 }}>
            {formatCurrency(r.valor_total)}
          </span>
        </Tooltip>
      )
    },
    {
      title: "% Entrega",
      dataIndex: "porcentaje_entrega",
      align: "center",
      width: 130,
      render: (v) => {
        let percent = Number(v) || 0;

        percent = Math.min(percent, 100);

        // 🚦 colores tipo semáforo
        let color = "red"; // bajo
        if (percent === 100) color = "green"; // completo
        else if (percent >= 50) color = "orange"; // medio

        return (
          <Tag color={color}>
            {percent === 100 ? "100%" : `${percent.toFixed(2)}%`}
          </Tag>
        );
      }
    }
  ];

  return (
    <Table
      style={{ paddingTop: 20, paddingBottom: 20 }}
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="oid"
      size="small"
      scroll={{ x: 900 }}
    />
  );
}